/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Creditcosttag2Inputs */

const en_creditcosttag2 = /** @type {(inputs: Creditcosttag2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· ${i?.cost} credits`)
};

const de_creditcosttag2 = /** @type {(inputs: Creditcosttag2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· ${i?.cost} Credits`)
};

/**
* | output |
* | --- |
* | "· {cost} credits" |
*
* @param {Creditcosttag2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditcosttag2 = /** @type {((inputs: Creditcosttag2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditcosttag2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditcosttag2(inputs)
	return de_creditcosttag2(inputs)
});
export { creditcosttag2 as "creditCostTag" }